import * as React from 'react';
type Props = {
  className?: string;
};
export function HighProtein({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-HighProtein"
      className={className}
    >
      <path
        d="M35.7856 23.1351C34.946 22.7251 33.6967 22.1493 32.1349 21.5734C29.9581 20.7828 27.84 20.0214 25.019 19.8749C24.0039 19.8163 22.4812 19.7481 20.5876 20.2069C17.9422 20.8413 16.4293 22.0517 16.1266 22.2957C15.9509 22.4421 15.8046 22.569 15.707 22.6569C15.6679 22.6959 15.5605 22.8033 15.3848 22.8423C15.1603 22.8911 14.9944 22.7935 14.9553 22.7643C14.9261 22.5104 14.9065 22.2566 14.8969 22.0029C14.7406 17.8837 16.9368 11.7928 19.4846 12.681C22.5202 13.7352 24.1015 13.9403 24.6384 14.0378C28.9039 14.8676 26.8346 11.988 29.1285 11.6463C31.8421 11.2461 31.2271 5.19424 30.1826 4.31577C27.5862 2.14881 23.2328 3.09564 20.1287 4.06198C9.80146 7.31246 6.77551 21.9736 6.3851 23.9844C6.2484 24.1503 4.36457 26.4539 5.22354 29.0015C5.8873 30.9636 7.76138 31.8226 8.56189 32.1934C9.70389 32.7107 10.7483 32.8279 11.4024 32.8474C13.4619 33.9894 17.1614 35.6685 22.042 35.9417C23.9062 36.0491 27.9376 36.2248 32.4278 34.2237C33.8138 33.599 34.907 32.9256 35.6684 32.3985M22.6179 9.44033C22.7936 9.69417 22.7252 10.3384 22.8228 10.5141C22.8814 10.6215 23.0083 10.6995 23.1058 10.7483C23.594 10.68 24.4237 10.6117 25.4096 10.7288C26.1026 10.8068 26.6393 10.9631 27.0103 11.0802C27.6643 11.4608 28.1523 11.6073 28.4843 11.5194C29.1578 11.3437 29.5482 8.36668 28.2109 7.42959M26.1205 10.8431C26.1205 10.8431 26.6842 8.89718 25.4778 7.87857"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
